import React from 'react';
import { IWidgetParsedProps } from '../../../../inputs/common/util/getWidgetProps';
import { ISubsectionWidget } from '../../ISubsectionWidget';

export interface ISubsectionInlineComponentProps {
  widget: ISubsectionWidget;
  options: IWidgetParsedProps;
  children?: React.ReactNode;
}

export function SubsectionInlineComponent(
  props: ISubsectionInlineComponentProps,
) {
  return props.children;
}
